import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip, Dropdown, NavLink } from 'react-bootstrap';
import listing from '../../../data/listings.json';
import ListingCard from '../ListingCard';

const gallerytip = <Tooltip>Gallery</Tooltip>;
const bedstip = <Tooltip>Beds</Tooltip>;
const bathstip = <Tooltip>Bathrooms</Tooltip>;
const areatip = <Tooltip>Square Feet</Tooltip>;

const Recentlisting = ({recentProperties}) => {
  return (
    <div className='section section-padding'>
      <div className='container'>
        <div className='section-title-wrap section-header flex-header'>
          <div className='section-title-text'>
            <h5 className='custom-primary'>Find Your Home</h5>
            <h2 className='title'>Recent Listings</h2>
          </div>
          <Link to='/listings' className='btn-custom'>
            View All
          </Link>
        </div>
        <div className='row'>
          {/* Listing Start */}
          {recentProperties.slice(0, 3).map((item, i) => (
            <div key={i} className='col-lg-4'>
                <ListingCard item={item} />
            </div>
          ))}
          {/* Listing End */}
        </div>
      </div>
    </div>
  );
};

export default Recentlisting;
